import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { Divider, Tabs } from 'shared/ui'
import { useMembersViewContext } from 'pages/settings/pages/members/pages/membersView/context/membersViewContext'
import { MembersPath } from 'pages/settings/pages/members/route/membersPath'
import { MembersRoutes } from 'pages/settings/pages/members/route/type'
import styles from './styles.module.scss'

export const RequestsLayout = observer(() => {
  const { requestsMembersStore } = useMembersViewContext()
  const { tabs } = requestsMembersStore

  return (
    <div className={styles.container}>
      <Tabs
        variant={'simpleWithoutBorder'}
        tabs={tabs}
        isNavigate
        disabledVueRouting
        navigateBasePath={`/${MembersPath.root}/${MembersRoutes.requests}`}
        tabsClassName={styles.tabs}
        countVariant={'white'}
      />
      <Divider sx={{ margin: '16px 7px', borderColor: 'var(--border-neutral-default)' }} />
      <Outlet />
    </div>
  )
})
